import {AAtmosphere} from "@/views/editor/service/atmosphere/atmosphere";
import {IBizAtmosphere, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";
import {Component, defineComponent, h} from "vue";
import {SafetyOutlined} from "@ant-design/icons-vue";

export default class Shield extends AAtmosphere implements IBizAtmosphere {
    readonly icon = () => h(SafetyOutlined, {style: 'color:#22c55e'});
    readonly title = '策略护盾';
    readonly description = '活动结束瞬间自动切换到“收官页面”，为您的核心营销策略披上专业“护盾”，严防创意被窥探。';
    readonly preview = 'https://static.pms.guandb.cn/media/system/console/20260129213702_5211_70.jpg'

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }

    resetMeta(): IBusiness {
        return this;
    }

    getBaseController(): Component {
        return defineComponent({})
    }
}